#!/usr/bin/env node
/*!
 * ContractCase Connector
 * Copyright(c) 2022-2024 Timothy Jones (TLJ)
 * BSD-3-Clause license
 */
import { main } from '../src/connectors/grpc/contract-case-stream.mjs';
main();
//# sourceMappingURL=case-connector.mjs.map